import React from 'react';

import cx from 'classnames';

import Render from 'components/render';
import { AVAILABLE_THEMES } from 'constants/constants';
import { OAUTH_PROVIDERS } from 'constants/enums';
import { GoogleIcon, AppleIcon } from 'styles/assets/icons';
import { Box } from 'UIKit';

import { OAuthIconWrapperProps } from './interface';
import classes from './oauth.module.scss';

const OAuthIconWrapper = ({
  color = AVAILABLE_THEMES.LIGHT,
  provider,
}: OAuthIconWrapperProps) => {
  return (
    <Box
      className={cx(classes.iconWrapper, {
        [classes.appleIconPadding]: provider === OAUTH_PROVIDERS.APPLE,
        [classes.bgLight]: color === AVAILABLE_THEMES.LIGHT,
        [classes.bgDark]: color === AVAILABLE_THEMES.DARK,
      })}
    >
      <Render when={provider === OAUTH_PROVIDERS.GOOGLE}>
        <GoogleIcon height="14" width="14" />
      </Render>
      <Render when={provider === OAUTH_PROVIDERS.APPLE}>
        <AppleIcon height="14" width="14" viewBox="0 0 20 25" />
      </Render>
    </Box>
  );
};

OAuthIconWrapper.displayName = 'OAuthIconWrapper';

export default OAuthIconWrapper;
